import React from 'react';
import { DollarSign, FileText, Shield, Home } from 'lucide-react';

/**
 * Компонент для ввода информации о комиссиях и сборах при рефинансировании
 */
const FeesSection = ({ formData, handleInputChange, errors }) => {
  if (!formData.includeFees) return null;

  return (
    <div className="mb-6 bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-900/10 dark:to-yellow-900/10 p-5 rounded-lg border border-amber-200 dark:border-amber-800/50 shadow-sm">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
        <DollarSign className="w-5 h-5 text-amber-500" />
        Комиссии и сборы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Единоразовая комиссия банка */}
        <div>
          <label htmlFor="initialFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <FileText className="w-4 h-4 mr-1 text-amber-500" />
            Единоразовая комиссия 
          </label>
          <input
            type="text"
            id="initialFee"
            name="initialFee"
            value={formData.initialFee}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.initialFee ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.initialFee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.initialFee}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Комиссия за выдачу и оформление нового кредита
          </p>
        </div>

        {/* Комиссия за досрочное погашение текущего кредита */}
        <div>
          <label htmlFor="earlyRepaymentFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-1 text-amber-500" />
            Комиссия за досрочное погашение
          </label>
          <input
            type="text"
            id="earlyRepaymentFee"
            name="earlyRepaymentFee"
            value={formData.earlyRepaymentFee}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentFee ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.earlyRepaymentFee && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentFee}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Комиссия текущего банка за досрочное закрытие кредита
          </p>
        </div>

        {/* Стоимость страховки */}
        <div>
          <label htmlFor="insuranceCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Shield className="w-4 h-4 mr-1 text-amber-500" />
            Стоимость страховки
          </label>
          <input
            type="text"
            id="insuranceCost"
            name="insuranceCost"
            value={formData.insuranceCost}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.insuranceCost ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.insuranceCost && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.insuranceCost}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Стоимость страхования жизни, здоровья или имущества
          </p>
        </div>

        {/* Стоимость оценки */}
        <div>
          <label htmlFor="valuationCost" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Home className="w-4 h-4 mr-1 text-amber-500" />
            Стоимость оценки
          </label>
          <input
            type="text"
            id="valuationCost"
            name="valuationCost"
            value={formData.valuationCost}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.valuationCost ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.valuationCost && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.valuationCost}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Стоимость оценки и экспертизы залогового имущества
          </p>
        </div>
      </div>

      <div className="mt-4 text-sm text-amber-700 dark:text-amber-300 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-700">
        <div className="flex items-start">
          <DollarSign className="w-5 h-5 text-amber-500 mr-2 mt-0.5" />
          <div>
            <p className="font-medium">Комиссии влияют на выгоду от рефинансирования</p>
            <p className="text-xs mt-1">
              При расчете выгоды учитываются все комиссии и сборы. Рефинансирование считается целесообразным, если экономия на процентах превышает затраты на комиссии.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesSection;